/* quiz random questions */
const quiz_buttons = document.querySelectorAll('[data-antwort]');
const next_links = document.querySelectorAll('[data-next]');

if (quiz_buttons) {
	quiz_buttons.forEach(function (btn) {
	    btn.addEventListener('click', function () {

	    	var antwort = btn.dataset.antwort;
	    	var frage_id = btn.dataset.frage;

	    	var frage_wrap = document.getElementById("frage"+frage_id);
	    	var antwort_wrap = document.getElementById("antwort"+frage_id);

	    	// remove all active classes - reset before adding
	    	var frage_buttons = frage_wrap.querySelectorAll('[data-antwort]');
	    	for (var i = frage_buttons.length - 1; i >= 0; i--) {
	    		frage_buttons[i].classList.remove('active');
	    		frage_buttons[i].classList.add('disabled');
	    	}
	    	// adn add active
	    	btn.classList.add('active');
	    	btn.classList.add('opacity-100');

	    	// show/hide answers and wrap
	    	if (antwort_wrap) {
				antwort_wrap.classList.remove('opacity-0');
				antwort_wrap.classList.add('opacity-100');
				if (antwort == 1) {
					antwort_wrap.querySelector('.yes').style.display = 'block';
					antwort_wrap.querySelector('.no').style.display = 'none';
				} else {
					antwort_wrap.querySelector('.no').style.display = 'block';
					antwort_wrap.querySelector('.yes').style.display = 'none';
				}
			}
	    })
	})
}

if (next_links) {
	next_links.forEach(function (link) {
	    link.addEventListener('click', function () {

	    	var current_id = link.dataset.current;
	    	var next_id = link.dataset.next;

	    	var current_frage = document.getElementById("frage"+current_id);
	    	var next_frage = document.getElementById("frage"+next_id);
	    	
	    	if (current_frage) {
	    		current_frage.style.display = 'none';
	    	}
	    	if (next_frage) {
	    		next_frage.style.display = 'block';
	    		//current_frage.querySelector('.frage-content').classList.remove('opacity-0');
	    		setTimeout(() => {
        			next_frage.querySelector('.frage-content').classList.add('opacity-100');
    			}, 100);
	    	}
	    })
	})
}